
define(
	'TavanoTeam.CSExtensions.Shopping.EntryPoint'
,   [
		'TavanoTeam.CapSciExtensions.CSSearchSpringExt'
	,	'TavanoTeam.CapSciExtensions.CSSearchSpringExt.Footer'
	,	'TavanoTeam.CapSciExtensions.CSSearchSpringExt.ItemsSearcher.View'
	,	'TavanoTeam.CapSciExtensions.CSSearchSpringExt.SiteSearch.View'
	,	'TavanoTeam.CapSciExtensions.CSSearchSpringExt.PDP'
	,	'TavanoTeam.CapSciExtensions.CSSearchSpringExt.CartDetailed.View'

	,	'Profile.Model'

	,	'SC.Configuration'
	]
,   function (
		SearchSpringExt
	,	SearchSpringFooterExt
	,	SearchSpringItemsSearcher
	,	SearchSpringSiteSearch
	,	SearchSpringPDP
	,	SearchSpringCart

	,	ProfileModel
	
	,	Configuration
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{
			var self = this
			,	layout = container.getComponent('Layout');
			
			// Get Environment Component
			this.environment = container.getComponent('Environment');

			if(Configuration.get('searchSpring.enable'))
			{
				SearchSpringExt.loadSearchSpring(container);
				SearchSpringFooterExt.loadSearchSpringFooter(container);
				SearchSpringSiteSearch.loadSearchSpringSiteSearch(container);
				SearchSpringPDP.loadSearchSpringPDP(container);
				SearchSpringCart.loadSearchSpringCart(container);

				self.loadIntelliSuggestScript(layout);
			}
		}

	,	loadIntelliSuggestScript: function(layout)
		{
			// Exclude from SEO Page Generator
			if (!this.environment.isPageGenerator()) {
				layout.cancelableOn('beforeShowContent', function()
				{
					if(jQuery('script[src="//cdn.searchspring.net/intellisuggest/is.min.js"]').length == 0)
					{
						var script = jQuery('<script type="text/javascript" src="//cdn.searchspring.net/intellisuggest/is.min.js"></script>');
						
						jQuery('body').append(script);
					}
				});
			}
		}
	};
});
